import styled from 'styled-components';
import Nav from 'react-bootstrap/Nav';
import { LinkContainer } from 'react-router-bootstrap';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';


export const AnalysisPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 2rem;
    padding: 1% 3%;
    margin-top: 120px;
    margin-bottom: 50px;
    margin-left: 6%;
    margin-right: 6%;
    
    b {
        font-weight: bold;
        color: ${props => props.theme.evTeal};
    }
    
    @media only screen and (max-width: 600px) {
        margin-left: 1%;
        margin-right: 1%;
    }
`;

export const TopButton = styled.button`
    display: flex;
    flex-direction: row;
    width: 125px;
    background: none;
    border: none;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};

    &:hover {
        cursor: pointer;
        color: ${props => props.theme.eLime};
    }
    
    @media only screen and (max-width: 600px) {
        width: 150px;
    }
`;

export const StyledIcon = styled.img`
    width: 30px;
    color: ${props => props.theme.voltBlue};

    &:hover {
        color: ${props => props.theme.eLime};
    }
`;

export const AnalysisPageTitle = styled.h1`
    font-size: 3rem;
    color: ${props => props.theme.evTeal};
    text-align: left;
    margin-bottom: 0px;
`;

export const StyledNav = styled(Nav)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 50%;
    height: 60px;
    margin-top: 20px;

    @media only screen and (max-width: 1100px) {
        width: 100%;
        font-size: 1rem;
    }
`;

export const StyledNavItem = styled(Nav.Item)`
    underline: none;
`;

export const StyledLinkContainer = styled(LinkContainer)`
    border-bottom: solid ${props => props.isActive ? props.theme.voltBlue : '1px #B2B2B2'};
    color: ${props => props.isActive ? props.theme.voltBlue : props.theme.evTeal};
    width: 25%;
    hieght: 100%;

    &:hover {
        color: ${props => props.theme.voltBlue};
        border-bottom: solid ${props => props.theme.voltBlue};
        cursor: pointer;
    }
`;

export const StyledTextInputAnalysis = styled(Form.Control)`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    height: 40px;
    border-radius: 8px;
    width: ${props => props.width ? props.width : '25%'};
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    padding: 0 10px;
    color: ${props => props.theme.voltBlue};
    ${props => (props.isValid === false) ? `border: 2px solid red;`: null}
`;

export const TopBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
`;

export const AnalysisSubTitle = styled.p`
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    text-align: left;
    margin-bottom: 20px;
    font-weight: bold;
`;

export const AnalysisTopButtons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 30%;
`; 

export const Logo = styled.img`
    width: 50px;
    height: auto;
    padding: 1rem;
`;

// SUBPAGE STYLES

export const SubPageTitle = styled.h2`
font-size: 1.5rem;
color: ${props => props.theme.evTeal};
display: flex;
flex-direction: row;
text-align: left;
`;

export const KPIRow = styled.div`
    display: flex;
    flex-direction: row;
    width: ${props => props.width ? props.width : '100%'};
    justify-content: space-between;
    margin-top: 10px;

    @media only screen and (max-width: 600px) {
        width: 90%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 10px;
    }
`;

export const SubmitButton = styled.button`
    background-color: ${props => props.theme.evTeal};
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    width: 150px;
    height: 40px;
    align-self: left;
    font-size: 1rem;
    margin-top: 20px;

    &:hover {
        background-color: ${props => props.theme.eLime};
    }
    
    &:disabled {
        background-color: #b3b3b3;
        cursor: not-allowed;
    }
`;

export const StyledForm = styled.form`
    display: flex;
    flex-direction: row;
    width: ${props => props.width ? props.width : '100%'};
    height:  ${props => props.height ? props.height : null};
    justify-content: space-between;
    margin-top: 10px;

    @media only screen and (max-width: 600px) {
        width: 100%;
    }
`;

export const AddButton = styled(Button)`
    background-color: ${props => props.theme.ecoMint};
    color: ${props => props.theme.voltBlue};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    width: 100px;
    height: 40px;
    align-self: center;
    font-size: 1rem;

    &:hover {
        background-color: ${props => props.theme.eLime};
    }
    
    &:disabled {
        background-color: #b3b3b3;
        cursor: not-allowed;
    }

    @media only screen and (max-width: 500px) {
        width: fit-content;
        padding: 5px;
    }
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    color: ${props => props.theme.evTeal};
    cursor: pointer;
    font-size: 1rem;
    margin-top: 5px;
    font-weight: bold;
    margin-right: 5px;

    &:hover {
        color: red;
    }
`;

export const RevenueWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 30px;
    width: 100%;
`;